import { createContext, useContext, useState } from "react";
import { create, StoreApi, useStore } from "zustand";

type SignUpOwfStore = {
  shouldShowRealTimeOwF: boolean;
  setShouldShowRealTimeOwF: (shouldShowRealTimeOwF: boolean) => void;
};

const SignUpOwfStoreContext = createContext<
  StoreApi<SignUpOwfStore> | undefined
>(undefined);

export const SignUpOwfStoreProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [signUpOwfStore] = useState<StoreApi<SignUpOwfStore>>(() =>
    create<SignUpOwfStore>((set) => ({
      shouldShowRealTimeOwF: false,
      setShouldShowRealTimeOwF: (shouldShowRealTimeOwF: boolean) => {
        set({ shouldShowRealTimeOwF });
      },
    }))
  );

  return (
    <SignUpOwfStoreContext.Provider value={signUpOwfStore}>
      {children}
    </SignUpOwfStoreContext.Provider>
  );
};

export const useSignUpOwfStore = <T,>(
  selector: (state: SignUpOwfStore) => T
): T => {
  const signUpOwfStore = useContext(SignUpOwfStoreContext);
  if (!signUpOwfStore) {
    throw new Error("SignUpOwfStore not found");
  }
  return useStore(signUpOwfStore, selector);
};
